import React, { Component } from "react";
import PageHelmet from "../component/common/Helmet";
import Breadcrumb from "./common/Breadcrumb";
import WhatsAppButton from "../component/WhatsAppButton";
import { FiChevronUp } from "react-icons/fi";
import ScrollToTop from 'react-scroll-up';
import ProductPhotos from "../component/ProductPhotos";
import ContactTwo from "../elements/contact/ContactTwo";
import Header from "../component/header/Header";
import Footer from "../component/footer/Footer";

import { withTranslation } from 'react-i18next';

import portfolioImg1 from "../assets/images/portfolio/portfolio-1.png";
import portfolioImg2 from "../assets/images/portfolio/portfolio-2.png";
import portfolioImg3 from "../assets/images/portfolio/portfolio-3.png";
import portfolioImg4 from "../assets/images/portfolio/portfolio-4.png";

class Product_6 extends Component {
    render() {

        const { t } = this.props;

        return (
            <React.Fragment>
                <PageHelmet pageTitle={t('Colores y acabados')} />
                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png" />

                {/* Start Breadcrump Area */}
                <Breadcrumb title={t('Colores y acabados')} />
                {/* End Breadcrump Area */}

                {/* Start Whatsapp Button */}
                <div className="rn-contact-map-wrapper ptb--80 bg_color--5">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="section-title service-style--3 text-center mb--60 mb_sm--0">
                                <h2 className="title3">{t("conoce-productos")}</h2>
                            </div>
                        </div>
                    </div>
                    <div>
                        <ProductPhotos slug="finishes" />
                    </div>
                    <div>
                        <ProductPhotos slug="finishes_1" />
                    </div>
                </div>
                {/* End Whatsapp Button */}

                {/* Start Contact Page Area  */}
                <div className="rn-contact-page ptb--120 bg_color--1">
                    <ContactTwo />
                </div>
                {/* End Contact Page Area  */}

                {/* Start Whatsapp Button */}
                <div>
                    <WhatsAppButton />
                </div>
                {/* End Whatsapp Button */}

                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}

                <Footer />


            </React.Fragment>
        )
    }
}

export default withTranslation()(Product_6);
